exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-278a11d4]{min-width:290px}.notes[data-v-278a11d4]{max-width:210px;white-space:normal}", ""]);

// exports
